import { apiClient } from '../apiClient';
import { convertSegmentsToSubtitles, createSubtitlesFromSegments } from './subtitleUtil';
import { getExportFilename, exportFile } from '../utils/common';

const newLine = '\r\n';
const speakerColors = [
    "ffffff", "ffff00", "00ffff", "00ff00"
]

function combineSubtitlesToFullSrt(subtitles, speakersColor) {
    let fullSrt = "";
    let index = 1;
    for (let subtitle of subtitles) {
      fullSrt += index++;
      fullSrt += newLine;
      fullSrt += getSrtSubtitleWithColor(subtitle, speakersColor);
      fullSrt += newLine + newLine;
    }
    return fullSrt;
}

function getSrtSubtitleWithColor(subtitle, speakersColor) {
    let frame = `${subtitle.startFormatted(',')} --> ${subtitle.endFormatted(',')}` + newLine;
    frame += speakersColor.get(subtitle.speaker);
    for(let line of subtitle.lines) {
        frame += line + newLine;
    }
    return frame + newLine;
}

function setColorToSpeakers(speakers) {
    const colorToSpeakers = new Map();
    for (let index = 0; index < speakers.length; index++) {
        colorToSpeakers.set(speakers[index].id, speakerColors[index % speakerColors.length]);
    }
    return colorToSpeakers;
}

export function exportStl(transcript, fileName) {
  const subtitles = createSubtitlesFromSegments(transcript.segments);
  const stlContent = subtitles.toStl();
  const filename = getExportFilename(fileName, 'stl');
  exportFile(filename, stlContent);
}